export default __webpack_public_path__ + "static/media/usdt.4d75e806.svg";